var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-block btn-outline-primary",style:((_vm.buttonActive === true)?
          'background-color: green;color: white;':
          'color: green;'),attrs:{"id":"razor-pay-subscription-web-button","data-test":"razorPayWebSubscriptionPayBtn"},on:{"click":function($event){$event.preventDefault();return _vm.razorPaySubscription($event)}}},[_vm._v("\n    Pay\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }